import PropTypes from 'prop-types'

import ModalHeader from '../ModalContainer/components/PopupHeader/ModalHeader'

const SurveyModalContainer = ({
  modalBody,
  headerTitle,
  headerIcon,
  headerStyles = {},
  onClose = () => {},
  preview,
}) => {
  return (
    <div className="modal-container survey-modal-container">
      <div className="modal-container__content">
        <ModalHeader onClose={onClose} title={headerTitle} icon={headerIcon} style={headerStyles} />
        {modalBody}
      </div>
      {preview}
    </div>
  )
}

SurveyModalContainer.propTypes = {
  modalBody: PropTypes.node,
  preview: PropTypes.node,
  onClose: PropTypes.func,
  headerTitle: PropTypes.string,
  headerIcon: PropTypes.node,
  headerStyles: PropTypes.object,
}

export default SurveyModalContainer
